import * as React from 'react'
import ServicesHeader from 'vendors/components/services/ServicesHeader'
import ServicesList from 'vendors/components/services/ServicesList'
import { useParams, Navigate } from 'react-router-dom'
import ListSkeleton from 'vendors/components/skeletons/ListSkeleton'
import { Box } from '@mui/material'
import useServiceClassifications from 'vendors/components/services/useServiceClassifications'

const VendorManageServices: React.FC = () => {
  const { vendorId } = useParams<{ vendorId: string }>()

  const { isLoading, isError } = useServiceClassifications(vendorId as string)

  if (isError) {
    return <Navigate to="/error" replace />
  }

  return (
    <>
      <ServicesHeader />
      <Box sx={{ pt: 3 }}>{isLoading ? <ListSkeleton items={5} /> : <ServicesList vendorId={vendorId as string} />}</Box>
    </>
  )
}

export default VendorManageServices
